// extracted by mini-css-extract-plugin
export var text = "_3q-0";